export default __webpack_public_path__ + "static/media/speaker33.abbe6242.png";